'use client'
import React, { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { ArrowUpIcon } from '@heroicons/react/24/solid';

const ScrollToTop = () => {
  const pathname = usePathname();
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    setIsVisible(window.scrollY > 0);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function scrollToTop() {
    if (typeof window === 'undefined') return;
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  if (pathname?.startsWith('/admin')) return null;

  return (
    <button
      hidden={!isVisible}
      onClick={scrollToTop}
      className="
        fixed right-4 z-[60]
        bottom-24 md:bottom-4
        flex h-11 w-11 items-center justify-center
        bg-ink text-white rounded-full shadow-lg
        transition duration-300 hover:bg-ink-light
      "
      aria-label="Remonter en haut de page"
    >
      <ArrowUpIcon className="h-5 w-5" />
    </button>
  );
};

export default ScrollToTop;
